import React from 'react';
import { renderRoutes, RouteConfigComponentProps } from 'react-router-config';
import { Switch, withRouter } from 'react-router-dom';
import MenuReportDetail from './MenuReportDetail/MenuReportDetail';
import MenuReportMaster from './MenuReportMaster/MenuReportMaster';
import MenuReportPreview from './MenuReportPreview/MenuReportPreview';

function MenuReportView(props: RouteConfigComponentProps) {
  const { route } = props;

  return <Switch>{route && renderRoutes(route.children)}</Switch>;
}

export { MenuReportMaster, MenuReportDetail, MenuReportPreview };
export default withRouter(MenuReportView);
